import { combineReducers } from "@reduxjs/toolkit";

import loaderReducer from "@/store/loaderSlice";

import authReducer from "@/modules/auth/store/authSlice";

import jobReducer from "@/modules/jobs/store/jobSlice";

import teamReducer from "@/modules/team/store/teamSlice";

import applicationReducer from "@/modules/candidate/store/applicationSlice";

import candidatesReducer from "@/modules/hrPortal/store/candidates.slice";

import candidateDetailsReducer from "@/modules/hrPortal/store/candidateDetailsSlice";

import hrDashboardReducer from "@/modules/hrPortal/store/dashboardSlice";

import adminDashboardReducer from "@/modules/adminPortal/redux/adminDashboardSlice";
import masterDatabaseReducer from "@/modules/adminPortal/redux/masterDatabaseSlice";

import centralizedResumeDatabaseReducer from "@/modules/hrPortal/store/centralizedResumeDatabase.slice";
import myApplicationsReducer from "@/modules/candidate/store/myApplications.slice";
import applicationDetailsReducer from "@/modules/candidate/store/applicationDetails.slice";
import candidateProfileReducer from "@/modules/candidate/store/candidateProfile.slice"
import interviewReducer from "@/modules/hrPortal/store/interviewSlice";

const rootReducer = combineReducers({
  
  auth: authReducer,
  jobs: jobReducer,
  team: teamReducer,
  application: applicationReducer,
  loader: loaderReducer,
  candidates: candidatesReducer,
  candidateDetails: candidateDetailsReducer,
  interview: interviewReducer,
  hrDashboard: hrDashboardReducer,
  adminDashboard: adminDashboardReducer,
  centralizedResumeDatabase:
  centralizedResumeDatabaseReducer,
  myApplications: myApplicationsReducer,
  applicationDetails: applicationDetailsReducer,
  candidateProfile: candidateProfileReducer,
  masterDatabase: masterDatabaseReducer,
});

export default rootReducer;